import React, { MutableRefObject, useRef, useState } from "react";
import clsx from "clsx";
import { TbArrowsDiagonal2 } from "react-icons/tb";
import { TextArea as TextAreaProps } from "./index.types";
import "./index.css";
import Button from "../button";

export function TextArea({
  buttonDisabled = false,
  className = "",
  disabled = true,
  error = {
    is: false,
    message: "",
  },
  hasToggleButton = true,
  hideHeight = "5rem",
  label,
  labelClassName,
  isRequired,
  placeholder = "Insert value",
  showHeight = "10rem",
  backgroundColor,
  style = {},
  textareaClassName = "",
  ...rest
}: TextAreaProps): JSX.Element {
  const ref = useRef() as MutableRefObject<HTMLTextAreaElement>;
  const [isShow, setIsShow] = useState<boolean>(false);

  const handleClickToggle = () => {
    if (ref && ref.current) {
      if (isShow) {
        ref.current.style.height = hideHeight;
      } else {
        ref.current.style.height = showHeight; //(48 + ref.current.scrollHeight) + 'px';
      }
      setIsShow((prev) => !prev);
    }
  };

  return (
    <div
      className={clsx("textarea", className)}
      style={{ backgroundColor: backgroundColor, ...style }}
    >
      <div className="textarea__header">
        {label && <label className={labelClassName}>{label}</label>}
        {error && error.is && (
          <span className="textarea__header--error">
            {error.message as any}
          </span>
        )}
      </div>
      <textarea
        ref={ref}
        className={clsx(
          "textarea__input",
          error.is && "textarea__input--error",
          textareaClassName
        )}
        style={
          {
            height: hasToggleButton ? hideHeight : showHeight,
          } as React.CSSProperties
        }
        placeholder={placeholder}
        disabled={disabled}
        required={isRequired}
        {...rest}
      />
      {hasToggleButton && (
        <Button
          type="button"
          className={clsx(
            "textarea__button",
            isShow && "textarea__button--show",
            error.is && "textarea__button--error"
          )}
          onClick={handleClickToggle}
          disabled={buttonDisabled}
        >
          <TbArrowsDiagonal2 size="1.5rem" />
        </Button>
      )}
    </div>
  );
}

export default TextArea;
